<template>
  <div id="users" class="p-4">
    <div class="card w-100">
      <div class="card-header py-3">
        <div class="row justify-content-between">
          <div class="col-4">
            <div class="pt-2 font-bold text-uppercase">Users</div>
          </div>
          <div class="col-4">
            <v-select v-model="filters.role" :options="rolesSelect" :reduce="role => role.code" placeholder="Roles filter" class="v-select_small"/>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <button class="btn btn-create my-2 ml-4" @click="onShowCreateModal()">+ Add User</button>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Surname</th>
              <th scope="col" class="text-center">Date Registered</th>
              <th scope="col" class="text-center">Assessments Completed</th>
              <th scope="col" class="text-center">Active/Inactive</th>
              <th scope="col" class="text-center"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user of getUsers" :key="user.id">
              <th scope="row">{{ user.id }}</th>
              <td>{{ user.name }}</td>
              <td>{{ user.surname }}</td>
              <td class="text-center">{{ user.created_at }}</td>
              <td class="text-center">{{ user.results_count }}</td>
              <td class="text-center">
                <img src="../assets/img/userActive-icon.png" alt="Active" v-if="parseInt(user.status)">
                <img src="../assets/img/userInactive-icon.png" alt="Active" v-else>
              </td>
              <td class="text-center">
                <span class="cursor-pointer" @click="onShowEditModal(user)">
                  <img src="../assets/img/edit-icon.png">
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="7">
                <b-pagination
                        v-if="getUsersPagination.last_page > 1"
                        v-model="filters.page"
                        :total-rows="getUsersPagination.total"
                        :per-page="getUsersPagination.per_page"
                        aria-controls="my-table"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'Users',
    data() {
      return {
        rolesSelect: [
          {label: 'Admin', code: 'admin'},
          {label: 'User', code: 'user'},
        ],
        filters: {
          role: null,
          page: 1
        },
      }
    },
    computed: {
      ...mapGetters([
        'getUsers',
        'getUsersPagination',
      ])
    },
    mounted() {
      this.queryUsers()
    },
    watch: {
      'filters.page'(val) {
        this.filters.page = val
        this.setUsersFilters(this.filters)
        this.queryUsers()
      },
      'filters.role'(val) {
        this.filters.role = val
        this.setUsersFilters(this.filters)
        this.queryUsers()
      }
    },
    methods: {
      ...mapActions([
        'queryUsers',
        'showModal',
      ]),
      ...mapMutations([
        'setUsersFilters'
      ]),
      onShowCreateModal() {
        this.showModal({modal: 'ModalUser', data: {}})
      },
      onShowEditModal(user) {
        this.showModal({modal: 'ModalUser', data: user})
      }
    }
  }
</script>

<style>

</style>